import React, { FC } from 'react';
import moment from 'moment';
import styled from 'styled-components';
import { Price } from 'shared-types/Common';
import { useTranslations } from '@lang';
import { Price as PriceComponent } from '@common/components/Price';

const Wrapper = styled.div`
  padding: ${({ theme }) => theme.spaces.space1} 0;
  font-weight: normal;
  color: ${({ theme }) => theme.defaultColors.fontSecondary};
`;

type PricePerNightProps = {
  checkIn: string;
  checkOut: string;
  roomTotalPrice?: Price;
};

export const PricePerNight: FC<PricePerNightProps> = ({ checkIn, checkOut, roomTotalPrice }) => {
  const { t } = useTranslations();

  if (!roomTotalPrice) {
    return null;
  }

  const numberOfNights = moment(checkOut).diff(moment(checkIn), 'days');
  const { currencyCode, amount: totalAmount } = roomTotalPrice;
  const amount = totalAmount / numberOfNights;

  return (
    <Wrapper>
      {t('room.pricePerNight', {
        pricePerNight: <PriceComponent price={{ currencyCode, amount }} />,
      })}
    </Wrapper>
  );
};
